import {QueryKeys} from '@/configs/queryKeys';
import {Attachment} from '@/types/types';
import {Component} from './ComponentApi';
import {ProductType} from './ProductTypeApi';
import EntityApi, {BaseEntity} from './EntityApi';

export enum ProductStatus {
	NOT_ADDED,
	ADDDED_TO_CART,
}

export interface ProductComponent extends BaseEntity {
	product: Product;
	quantity: number;
	price: number;
	componentData: Omit<Component, 'render'> & {
		render: string;
	};
}

export interface Product extends BaseEntity {
	name: string;
	price: number;
	productType: ProductType;
	componentItems: Component[];
	productComponents: ProductComponent[];
	status: ProductStatus;
	previewImage?: Attachment;
	inscription?: string;
	options: string;
	width: number;
	height: number;
}

class ProductApi extends EntityApi<Product> {
	constructor() {
		super(QueryKeys.products);
	}
}

export default new ProductApi();
